import * as yup from "yup";

const RCVIValidationSchema = ()=>{
let schema = yup.object().shape({
agency: yup.string().max(250, "Name of Agency cannot exceed 250 characters").required("Name of Agency is required"),
telephone: yup.string().required("Telephone number is required").min(10, "Invalid Phone Number")
.max(11, "Invalid Phone Number"),
website: yup.string().max(500, "Website cannot exceed 500 characters").required("Website is required").url("Invalid Website ")
})
return(schema)
}
export default RCVIValidationSchema